import { string } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

function CardRecipes({ name, image, indice, id, pageSelected }) {
  return (

    <div data-testid={ `${indice}-recipe-card` }>
      <Link to={ `/${pageSelected}/${id}` }>
        <img
          data-testid={ `${indice}-card-img` }
          className="recipe-image"
          src={ image }
          alt={ name }
        />
        <p className="nome" data-testid={ `${indice}-card-name` }>{ name }</p>
      </Link>
    </div>

  );
}

const mapStateToProps = (state) => ({
  pageSelected: state.reducerFetch.pageSelected,
});

CardRecipes.propTypes = {
  name: string,
  image: string,
}.isrequired;

export default connect(mapStateToProps, null)(CardRecipes);
